import React from 'react'
import {Link} from 'react-router-dom'
import './Styles/products.css'
function Productpage({setproductd,content}) {
  return (
    <div className='product'>
      {
        content.map((product,index)=>{
          const viewproduct=()=>{
            setproductd(product);
          }
          return <div key={index} className='productscover'>
          <p>{product.title.slice(0,23)}</p>
          <Link to='product'><img src={product.images[0]} alt={product.title}  className='producti' onClick={viewproduct}/></Link>
          <p className='desc'>{product.description.slice(0,50)}</p>
          <div className="flex">
          <p className='price'>&#8377;{Math.floor(product.price*100 / product.discountPercentage - product.price)}00 <span style={{color:'black'}}>M.R.P</span><span className='original-price'>&#8377;{Math.floor(product.price*100 / product.discountPercentage)}00 </span></p>
          <span className="rating">{product.rating}&#10024;</span>
          </div>
          </div>
        })
      }
    </div>
  )
}
export default Productpage
